import React from 'react'
import { ORDER_MANAGER, REPORT } from '../../../../helpers'
import { OrderBottomBarStyle } from './styles'
import { connect } from 'react-redux'
import { MODAL, ORDER } from '../../../../reduxs'

function OrderBottomBar(props) {
  const {
    selectedTab,
    orderManagerTab,
    language,
    colorTheme,
    submitOrderText,
    
    openOrderCounterModal,
    setOrderActionAddOrder,
    openIssueReportModal,
    setOrderActionAddIssue,
    disabled,
  } = props

  const handleOpenAddOrderModal = () => {
    setOrderActionAddOrder(selectedTab)
    openOrderCounterModal()
  }

  const handleOpenIssueReportModal = () => {
    setOrderActionAddIssue(selectedTab)
    openIssueReportModal()
  }

  return (
    <OrderBottomBarStyle colorTheme={colorTheme} selectedTab={selectedTab} >
      {(selectedTab === orderManagerTab[ORDER_MANAGER.VALUE.CATERING].value ||
        selectedTab === orderManagerTab[ORDER_MANAGER.VALUE.EQUIPMENT].value) &&
        <div className='order-bottom-bar__box'>
          <button
            className={`order-bottom-bar__button ${disabled ? 'disabled' : ''}`}
            onClick={() => handleOpenAddOrderModal()}
            disabled={disabled}
          >
            {submitOrderText}
          </button>
        </div>
      }

      {selectedTab === orderManagerTab[ORDER_MANAGER.VALUE.FACILITY].value
        && (
          <div className='order-bottom-bar__box'>
            <div className='order-bottom-bar__text-box'>
              <p className='order-bottom-bar__title'>{REPORT.FACILITY_MAINTENANCE[language]}</p>
              <p className='order-bottom-bar__subtitle'>{REPORT.PROVIDE_ISSUE[language]}</p>
            </div>
            <button
              className={`order-bottom-bar__button ${disabled ? 'disabled' : ''}`}
              onClick={() => handleOpenIssueReportModal()}
              disabled={disabled}
            >
              {REPORT.REPORT[language]}
            </button>
          </div>
        )
      }
    </OrderBottomBarStyle>
  )
}

const mapStateToProps = ({ accountReducer }) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openOrderCounterModal: () => dispatch(MODAL.action.setOrderCounterModal(true)),
    openIssueReportModal: () => dispatch(MODAL.action.setIssueReportModal(true)),
    setOrderActionAddOrder: (selectedTab) => dispatch(ORDER.action.setOrderActionText(selectedTab, 'ADD')),
    setOrderActionAddIssue: (selectedTab) => dispatch(ORDER.action.setOrderActionText(selectedTab, 'REPORT')),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderBottomBar)
